import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type TCloseLoanForm = {
    paymentStatus: string;
    paymentDate: string;
    amount: number;
    interesetAmount: number;
    collectedAmount: number;
    collectedInterest: number;
    utr: string;
    paymentMode: string;
    comments: string;
    images: string[];
}

type TinitialState = {
    closeLoan: TCloseLoanForm,
};

const initialState: TinitialState = {
    closeLoan: {
        paymentStatus: "RECOVERED",
        paymentDate: "",
        amount: 0,
        utr: "",
        paymentMode: "",
        comments: "",
        images: [],
        collectedAmount: 0,
        interesetAmount: 0,
        collectedInterest: 0
    }
};

const cancelTradeSlice = createSlice({
    name: "cancelTrade",
    initialState: initialState,
    reducers: {
        setCancelTrade: (state, action: PayloadAction<{
            amount: number,
            interestAmt: number,
        }>) => {
            return {
                ...initialState,
                closeLoan: {
                    ...initialState.closeLoan,
                    amount: action.payload.amount,
                    interesetAmount: action.payload.interestAmt,
                },
            };
        },
        updateCancelTradeInput: (state, action: PayloadAction<{
            closeLoan: TCloseLoanForm,
        }>) => {
            state.closeLoan = action.payload.closeLoan;
        },
    },
});

export const {
    setCancelTrade,
    updateCancelTradeInput,
} =
    cancelTradeSlice.actions;
export default cancelTradeSlice.reducer;
